export default "__VITE_ASSET__2eb701b2__"